import {
  LumabotFlow,
  LumabotFlowActualAnswer,
} from 'types-model-repository/types.d';
import {
  ELumaBotFlowType,
  ILumaBotTemplateItem,
} from '../lumaBotFlowTemplateModel';
import { ELanguage } from '../../interfaces';

export enum ELumaBotFlowStatus {
  Started = 'started',
  Completed = 'completed',
}
export enum ELumaBotFlowProcessingStatus {
  Open = 'open',
  InProgress = 'in-progress',
  Closed = 'closed',
}
export interface ILumaBotFlow
  extends Omit<
    LumabotFlow,
    | 'completedAt'
    | 'flowType'
    | 'language'
    | 'nextLumabotFlow'
    | 'previousLumabotFlow'
    | 'processingStatus'
    | 'questions'
    | 'status'
  > {
  completedAt?: string;
  flowType?: ELumaBotFlowType;
  language?: ELanguage;
  nextLumabotFlow?: ILumaBotFlow;
  previousLumabotFlow?: ILumaBotFlow;
  processingStatus?: ELumaBotFlowProcessingStatus;
  questions?: ILumaBotFlowQuestion[];
  status?: ELumaBotFlowStatus;
}
export interface ILumaBotFlowActualAnswer
  extends Omit<LumabotFlowActualAnswer, 'createdAt'> {
  createdAt?: string;
}
export interface ILumaBotFlowQuestion extends ILumaBotTemplateItem {
  answer?: ILumaBotFlowActualAnswer;
  askedAt?: string;
  lumabotFlowId?: string;
  lumabotFlowTemplate?: string;
}

export enum ELumaBotFlowMessagesHistorySource {
  LumaBot = 'lumabot',
  Patient = 'patient',
}

export interface ILumaBotFlowMessagesHistory {
  source: ELumaBotFlowMessagesHistorySource;
  text: string;
  createdAt: string;
}

export interface ILumaBotFlowResponses {
  endDate: string;
  id: string;
  messages: ILumaBotFlowMessagesHistory[];
  startDate: string;
  title: string;
}
